// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Card: {
    select: 'Seleccionar',
    titleLinkTooltip: 'Anar a la pàgina',
    collapseCardTooltip: 'Contraure la targeta',
    expandCardTooltip: 'Expandir la targeta'
  },
  CardList: {
    loadMore: 'Carregar-ne més',
    notFound: "No s'ha trobat cap element.",
    toolbarSelect: 'Seleccionar',
    viewCards: 'Targetes',
    viewTiles: 'Mosaic',
    viewList: 'Llista',
    toolbarView: 'Vista'
  },
  ClosingConfirmation: {
    confirm: 'Sortir',
    cancel: 'Tornar',
    content: 'Segur que vol tancar la finestra? No es desaran els canvis.'
  },
  Cuttable: {
    showMore: 'Mostrar-ne més',
    showLess: 'Mostrar-ne menys'
  },
  Dialog: {
    cancelButton: 'Cancel·lar'
  },
  DrawerProgress: {
    cancelButton: 'Cancel·lar'
  },
  Dropdown: {
    close: 'Tancar'
  },
  Form: {
    submitButton: 'Desar',
    applyButton: 'Aplicar',
    cancelButton: 'Cancel·lar'
  },
  FormField: {
    clear: 'Esborrar',
    remove: 'Eliminar',
    addMore: 'Afegir-ne un altre'
  },
  FormFieldPassword: {
    improvePassword: 'Per millorar la seva contrasenya:',
    passwordTooShort: 'Augmenti la longitud de la contrasenya.',
    lettersLowerCase: 'Utilitzi almenys un caràcter en minúscula.',
    lettersUpperCase: 'Utilitzi almenys un caràcter en majúscula.',
    numbers1: 'Utilitzi almenys un número.',
    numbers3: 'Utilitzi almenys tres números.',
    specialChar1: 'Utilitzi almenys un caràcter especial (per exemple: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Utilitzi almenys dos caràcters especials (per exemple: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Utilitzi caràcters tant en majúscules com en minúscules.',
    comboLettersAndNumbers: 'Utilitzi tant números com lletres.',
    comboLettersNumbersSpecial: 'Utilitzi números, lletres i caràcters especials.',
    yourPasswordIsStrong: 'Pot fer-la encara més segura augmentant-ne la longitud.',
    passwordStrength: 'Seguretat de la contrasenya: %%strength%%.',
    strengthVeryStrong: 'MOLT SEGURA',
    strengthStrong: 'SEGURA',
    strengthVeryWeak: 'MOLT POC SEGURA',
    strengthWeak: 'POC SEGURA',
    strengthMedium: 'MITJANA',
    hidePassword: 'Ocultar la contrasenya',
    showPassword: 'Mostrar la contrasenya',
    generateButton: 'Generar',
    copyButtonHint: 'Copiï la contrasenya',
    copySuccessToast: "S'ha copiat la contrasenya",
    generateButtonHint: 'Generi una contrasenya segura'
  },
  InPlaceEdit: {
    editButtonHint: 'Editi el valor',
    okButtonHint: 'Desi els canvis',
    cancelButtonHint: 'Descarti els canvis'
  },
  InputFile: {
    browseButton: 'Seleccionar un arxiu...'
  },
  List: {
    totalRows: 'Elements en total: %%totalRows%%',
    selectedRows: 'Elements seleccionats: %%selectedRows%% de %%totalRows%%',
    all: 'tots',
    allItemsOnPageSelected: 'Tots els elements de la pàgina seleccionats',
    allItemsSelected: 'Tots els elements seleccionats',
    selectAllItems: 'Seleccionar tots els elements',
    selectAllItemsOnPage: 'Seleccionar tots els elements de la pàgina',
    deselectAll: 'Deseleccionar'
  },
  ListEmptyView: {
    filteredTitle: "No s'ha trobat cap element que coincideixi amb el filtre",
    emptyTitle: 'Sembla que aquí no hi ha res',
    filteredDescription: 'Restringeixi la seva consulta o elimini alguns dels criteris del filtre i torni-ho a provar.'
  },
  ListOperation: {
    cancelButton: 'Cancel·lar'
  },
  Pagination: {
    totalShort: 'de %%total%%',
    itemsPerPage: 'Elements per pàgina',
    all: 'Tot',
    total: 'Pàgina %%current%% de %%total%%'
  },
  ProgressDialog: {
    closeButton: 'Tancar',
    cancelButton: 'Cancel·lar'
  },
  Select: {
    noOptions: 'No hi ha opcions',
    placeholder: 'Seleccionar...'
  },
  SpotPopup: {
    total: '%%current%% de %%total%%'
  },
  Toaster: {
    closeGroup: 'Tancar el grup'
  }
};